export default __webpack_public_path__ + "static/media/745-tile.1ccf081e.svg";